import { render, staticRenderFns } from "./Constructions.vue?vue&type=template&id=870f28be"
import script from "./Constructions.vue?vue&type=script&lang=js"
export * from "./Constructions.vue?vue&type=script&lang=js"
import style0 from "./Constructions.vue?vue&type=style&index=0&id=870f28be&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports